export const THEME_COLOR_KEYS = [
  'primary',
  'primary-content',
  'secondary',
  'secondary-content',
  'accent',
  'accent-content',
  'neutral',
  'neutral-content',
  'base-100',
  'base-200',
  'base-300',
  'base-content',
  'border',
  'sidebar'
] as const;

export type ThemeColorKey = (typeof THEME_COLOR_KEYS)[number];

export type ThemePalette = Partial<Record<ThemeColorKey, string>>;

export type ThemeMode = 'light' | 'dark';

export interface TenantTheme {
  light: ThemePalette;
  dark?: ThemePalette;
  radius?: number;
  mode?: ThemeMode;
}

export type TenantThemeVars = Record<string, string>;

export interface AppliedTenantTheme {
  light: TenantThemeVars;
  dark: TenantThemeVars;
}

export const CONTENT_PAIRS: [ThemeColorKey, ThemeColorKey][] = [
  ['primary', 'primary-content'],
  ['secondary', 'secondary-content'],
  ['accent', 'accent-content'],
  ['neutral', 'neutral-content'],
  ['base-100', 'base-content']
];

export const SURFACE_KEYS: ThemeColorKey[] = ['base-100', 'base-200', 'base-300', 'base-content', 'border', 'sidebar'];

export const DEFAULT_RADIUS = 0.625;

export const PLATFORM_PALETTE: Record<ThemeMode, Record<ThemeColorKey, string>> = {
  light: {
    primary: '#06f66a',
    'primary-content': '#1f2937',
    secondary: '#f43098',
    'secondary-content': '#f9e4f0',
    accent: '#06f66a',
    'accent-content': '#1f2937',
    neutral: '#09090b',
    'neutral-content': '#e4e4e7',
    'base-100': '#ffffff',
    'base-200': '#f1f5f9',
    'base-300': '#eeeeee',
    'base-content': '#020618',
    border: '#e2e8f0',
    sidebar: '#ffffff'
  },
  dark: {
    primary: '#06f66a',
    'primary-content': '#1f2937',
    secondary: '#1d232a',
    'secondary-content': '#f2f2f2',
    accent: '#06f66a',
    'accent-content': '#1f2937',
    neutral: '#15191e',
    'neutral-content': '#f2f2f2',
    'base-100': '#1d232a',
    'base-200': '#191e24',
    'base-300': '#15191e',
    'base-content': '#f2f2f2',
    border: '#4e5158',
    sidebar: '#1d232a'
  }
};

export const GOSKALER_THEME: TenantTheme = { light: {} };
